import { EyeIcon, EyeOffIcon } from 'lucide-react';
import { useState, type ComponentProps } from 'react';

import { InputGroup, InputGroupAddon, InputGroupInput, InputGroupButton } from '@/components/ui/input-group';

export function PasswordInput(passwordInputProps: ComponentProps<'input'>) {
  const { value, onChange, name = 'password', placeholder = 'Password', autoComplete = 'current-password', className, ...props } = passwordInputProps;

  const [isVisible, setIsVisible] = useState<boolean>(false);
  const toggleVisibility = () => setIsVisible((prev) => !prev);

  return (
    <InputGroup>
      <InputGroupInput type={isVisible ? 'text' : 'password'} name={name} value={value} onChange={onChange} placeholder={placeholder} autoComplete={autoComplete} className={className} {...props} />
      <InputGroupAddon align="inline-end">
        <InputGroupButton size="sm" type="button" onClick={toggleVisibility}>
          {isVisible ? <EyeOffIcon /> : <EyeIcon />}
        </InputGroupButton>
      </InputGroupAddon>
    </InputGroup>
  );
}
